/* eslint-disable no-undef */
import axios from 'axios';
import { configureHttpHeaders, onSuccess, onError } from './apiHelpers';
import { VITE_USER_MANAGER_API } from 'Constants/appEnvConstants';

export function exportUserManagerReportData(data) {
  let url;
  url = `api/v1/usermanagement/dims/user/export`;
  configureHttpHeaders(axios);
  return postBlob(`${VITE_USER_MANAGER_API}${url}`, data);
}

export function userManagerReportData(reportId, pageNumber, size, sort, reportSearchView) {
  let objField = {};
  let fieldArr = [];
  let filterarr = [];

  sort.forEach((element) => {
    // eslint-disable-next-line no-unused-expressions
    (objField['fieldId'] = getFieldName(element)), (objField['orderByProperty'] = element.order ? 'ASC' : 'DESC');
  });
  fieldArr.push(objField);

  if (reportSearchView.searchFilterInputElements.length > 0) {
    reportSearchView.searchFilterInputElements.forEach((col) => {
      filterarr.push({ columnKey: getcolumnKey(col.elementId), columnValue: col.elementValue });
    });
  }
  let queryInput = {
    pageNumber: pageNumber,
    size: size,
    sortingElement: fieldArr,
    searchFilterElements: filterarr,
  };
  configureHttpHeaders(axios);
  return postBlob(`${VITE_USER_MANAGER_API}api/v1/usermanagement/dims/user/report`, queryInput);
}

export function getFilterValuesBasedOnElementIdForUserReport(elementId) {
  configureHttpHeaders(axios);
  if (elementId === 'user_role') {
    return getValue(`${VITE_USER_MANAGER_API}api/v1/usermanagement/userrole`);
  } else if (elementId === 'acquirer_code') {
    return getValue(`${VITE_USER_MANAGER_API}api/v1/usermanagement/acquirercode`);
  }
}
function getValue(url) {
  return axios.get(`${url}`).then(onSuccess).catch(onError);
}

function postBlob(postUrl, body) {
  return axios({
    method: 'post',
    url: postUrl,
    data: body,
  })
    .then(onSuccess)
    .catch(onError);
}

// eslint-disable-next-line no-unused-vars
function getBlob(baseUrl, url, document) {
  axios.defaults.headers.common.Accept = 'application/octet-stream';
  configureHttpHeaders(axios);
  let resType = 'text/csv';

  const params = {
    fileName: document.fileName,
    fileDirectoryId: document.fileDirectoryId,
  };

  return axios
    .get(`${baseUrl}${url}`, { params, responseType: 'arraybuffer' })
    .then(onSuccess)
    .then((response) => {
      const blob = new Blob([response], { type: resType });
      return blob;
    })
    .catch(onError);
}

// eslint-disable-next-line no-unused-vars
function get(baseUrl, url, data) {
  const params = {
    reportGeneratedDate: data,
  };
  return axios.get(`${baseUrl}${url}`, { params }).then(onSuccess).catch(onError);
}

// eslint-disable-next-line no-unused-vars
function getBase(baseURL, url) {
  return axios.get(`${baseURL}${url}`).then(onSuccess).catch(onError);
}

export function getFieldName(element) {
  let fieldId = 'first_login_date';
  switch (element.key) {
    case 'firstName':
      fieldId = 'first_name';
      break;
    case 'lastName':
      fieldId = 'last_name';
      break;
    case 'userRole':
      fieldId = 'user_role_key';
      break;
    case 'dimsStatus':
      fieldId = 'status';
      break;
    case 'acquirerCode':
      fieldId = 'acquirer_code';
      break;
    case 'createDate':
      fieldId = 'create_date';
      break;
    case 'firstLoginDate':
      fieldId = 'first_login_date';
      break;
    case 'lastLoginDate':
      fieldId = 'last_login_date';
      break;
    case 'email':
      fieldId = 'email';
      break;
    case 'userType':
      fieldId = 'user_type';
      break;
  }
  return fieldId;
}

export function getcolumnKey(element) {
  let key = '';
  switch (element) {
    case 'first_name':
      key = 'firstName';
      break;
    case 'last_name':
      key = 'lastName';
      break;
    case 'status':
      key = 'userStatus';
      break;
    case 'create_date_from':
      key = 'createdDateFrom';
      break;
    case 'create_date_to':
      key = 'createdDateTo';
      break;
    case 'first_login_from':
      key = 'firstLoginDateFrom';
      break;
    case 'first_login_to':
      key = 'firstLoginDateTo';
      break;
    case 'last_login_from':
      key = 'lastLoginDateFrom';
      break;
    case 'last_login_to':
      key = 'lastLoginDateTo';
      break;
    case 'email':
      key = 'email';
      break;
    case 'user_type':
      key = 'userType';
      break;
    case 'acquirer_code':
      key = 'acquirerCode';
      break;
    case 'user_role':
      key = 'userRole';
      break;
  }
  return key;
}

export default {
  exportUserManagerReportData,
  userManagerReportData,
  getFieldName,
};
